import { xVwapLabel } from 'widgets/fillsGraph/legend/labels';

export enum PnlBenchmark {
    /*
     * Uses fixed benchmark price for earliest arrival time across all orders
     */
    Arrival = 'Arrival',
    /*
     * Uses arrival price for each order individually
     */
    IndividualOrderArrival = 'IndividualOrderArrival',
    Vwap = 'Vwap',
    Last = 'Last',
    Open = 'Open',
    Pnc = 'Pnc',
}

export const shortArrivalLabel = 'Arrival Time';
export const earliestArrivalLabel = 'Earliest Arrival Time';
export const individualArrivalLabel = 'Arrival Time (for each order)';
export const lastLabel = 'Last';
export const openLabel = 'Open';
export const pncLabel = 'Prev Close';
export const totalPnLLabel = 'Total P&L';

const getPnLLabelMsg = (type: 'realized' | 'unrealized', typeLabel: string) =>
    `${type === 'realized' ? 'Realized' : 'Unrealized'} P&L by ${typeLabel}`;

export function getPnLLegendLabelByBenchmark(
    type: 'realized' | 'unrealized',
    pnlChartBenchmark: PnlBenchmark
) {
    switch (pnlChartBenchmark) {
        case PnlBenchmark.Arrival:
        case PnlBenchmark.IndividualOrderArrival:
            return getPnLLabelMsg(type, shortArrivalLabel);
        case PnlBenchmark.Vwap:
            return getPnLLabelMsg(type, xVwapLabel);
        case PnlBenchmark.Last:
            return getPnLLabelMsg(type, lastLabel);
        case PnlBenchmark.Open:
            return getPnLLabelMsg(type, openLabel);
        case PnlBenchmark.Pnc:
            return getPnLLabelMsg(type, pncLabel);
    }
}
